import React from 'react';
import classNames from 'classnames';
import { XOR } from '../../types';
import { Button } from 'ncoded-component-library';
import InformationcircleIcon from '../../icons/Informationcircle.icon';

import './HintMessage.styles.scss';
import './HintMessage.styles.responsive.scss';

type HintMessageType = 'default' | 'error' | 'info' | 'success';

type WithAction = {
  onActionClick: () => void;
  actionButtonText: string;
  actionIcon?: React.ReactNode;
};

type WithoutAction = {
  withAction?: false;
};

type HintMessageProps = {
  className?: string;
  title?: string;
  type?: HintMessageType;
  message?: React.ReactNode;
} & XOR<WithAction, WithoutAction>;

const HintMessage: React.FC<HintMessageProps> = (props) => {
  const {
    className,
    type = 'default',
    message,
    onActionClick,
    actionButtonText,
    actionIcon,
    title,
  } = props;

  const classes = classNames('hint-message', type, className);

  return (
    <div className={classes}>
      <InformationcircleIcon />
      <div className="hint-message__content">
        {title && <p className="hint-message__content__title">{title}</p>}
        <div>{message}</div>
        {actionButtonText && (
          <Button
            icon={actionIcon}
            onClick={() => (onActionClick as () => void)()}
          >
            {actionButtonText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default HintMessage;
